<script setup>
import misc404 from '@/assets/images/pages/404.png'
import miscMaskDark from '@/assets/images/pages/misc-mask-dark.png'
import miscMaskLight from '@/assets/images/pages/misc-mask-light.png'
import topImage from '@/assets/images/pages/home_masthead.jpg'

// import reservedImage from '@/assets/images/pages/AdobeStock_58798975.jpeg'
// import chicagoImage from '@/assets/images/cities/chicago.jpg'
// import nycImage from '@/assets/images/cities/nyc.jpg'
// import miamiImage from '@/assets/images/cities/miami.jpg'

import logo from '@/assets/logo-400.png'
import logoLargeLight from '@/assets/logo-large-light.svg'
import {useGenerateImageVariant} from '@core/composable/useGenerateImageVariant'

const authThemeMask = useGenerateImageVariant(miscMaskLight, miscMaskDark)
</script>

<template>
  <div>
    <section class="alternate-masthead">
      <div class="home-masthead-bkg-holder">
        <img
          class="home-masthead-bkg"
          :src="topImage"
        >
      </div>
      <div class="content-wrapper">
        <div class="masthead-content">
          <img
            class="masthead-content-logo"
            :src="logoLargeLight"
          >
          <h2 class="masthead-content-headline">
            Privacy Policy
          </h2>
        </div>
      </div>
    </section>
    <section class="site-section site-section--lighter">
      <div class="content-wrapper">
        <div data-custom-class="body">
          <div>
            <strong><span style="font-size: 26px;"><span data-custom-class="title"><span
              class="block-component"
            /><span class="statement-end-if-in-editor" /></span></span></strong>
          </div>
          <div>
            <span style="color: rgb(127, 127, 127);"><strong><span style="font-size: 15px;"><span
              data-custom-class="subtitle"
            >Last updated <span
              class="question"
            >Nov 7, 2023</span></span></span></strong></span>
          </div>
          <div><br></div>
          <div style="line-height: 1.5;">
            <span style="color: rgb(127, 127, 127);"><span
              style="color: rgb(89, 89, 89); font-size: 15px;"
            ><span data-custom-class="body_text">This privacy notice for <span
              class="question"
            >RecommendMe, Inc.<span class="block-component" /></span> (<span
              class="block-component"
            />"<strong>we</strong>," "<strong>us</strong>," or "<strong>our</strong>"<span
              class="statement-end-if-in-editor"
            /></span><span data-custom-class="body_text">), describes how and why we might collect, store, use, and/or share (<span
              class="block-component"
            />"<strong>process</strong>"<span class="statement-end-if-in-editor" />) your information when you use our services (<span
              class="block-component"
            />"<strong>Services</strong>"<span class="statement-end-if-in-editor" />), such as when you:</span></span></span><span
              style="font-size: 15px;"
            ><span style="color: rgb(127, 127, 127);"><span
              data-custom-class="body_text"
            ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text">Visit our website<span
                class="block-component"
              /> at <span class="question">reserverm.com</span><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span class="statement-end-if-in-editor">, or any website of ours that links to this privacy notice</span></span></span></span></span></span></span></span></span>
            </li>
          </ul>
          <div>
            <span class="block-component"><span style="font-size: 15px;"><span style="font-size: 15px;"><span
              style="color: rgb(127, 127, 127);"
            ><span data-custom-class="body_text"><span
              style="color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span class="block-component" /></span></span></span></span></span></span>
            </span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text">Download and use<span
                class="block-component"
              /> our mobile application<span class="block-component" /> (<span
                class="question"
              >RM)<span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span
                class="statement-end-if-in-editor"
              >,</span></span></span></span></span></span></span></span></span></span></span><span
                data-custom-class="body_text"
              ><span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span
                data-custom-class="body_text"
              ><span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span
                class="statement-end-if-in-editor"
              ><span class="block-component"> or any other application of ours that links to this privacy notice</span></span></span></span></span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span style="color: rgb(127, 127, 127);"><span
              data-custom-class="body_text"
            ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text">Engage with us in other related ways, including any sales, marketing, or events<span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span
                class="statement-end-if-in-editor"
              /></span></span></span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span style="color: rgb(127, 127, 127);"><span
              data-custom-class="body_text"
            ><strong>Questions or concerns?&nbsp;</strong>Reading this privacy notice will help you understand your privacy rights and choices. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at <span
              class="question"
            >privacy@reserverm.com</span>.</span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <strong><span style="font-size: 15px;"><span data-custom-class="heading_1">SUMMARY OF KEY POINTS</span></span></strong>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><strong><em>This summary provides key points from our privacy notice, but you can find out more details about any of these topics by clicking the link following each key point or by using our&nbsp;</em></strong></span></span><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            ><strong><em>table of contents</em></strong></span></span><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><strong><em>&nbsp;below to find the section you are looking for.</em></strong></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><strong>What personal information do we process?</strong> When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features you use. Learn more about&nbsp;</span></span><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            >personal information you disclose to us</span></span><span
              data-custom-class="body_text"
            >.</span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><strong>Do we process any sensitive personal information?</strong> <span
              class="block-component"
            />We do not process sensitive personal information.<span
              class="else-block"
            /></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><strong>Do we receive any information from third parties?</strong> <span
              class="block-component"
            />We do not receive any information from third parties.<span
              class="else-block"
            /></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><strong>How do we process your information?</strong> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so. Learn more about&nbsp;</span></span><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            >how we process your information</span></span><span
              data-custom-class="body_text"
            >.</span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><strong>In what situations and with which <span
              class="block-component"
            />parties do we share personal information?</strong> We may share information in specific situations and with specific <span
              class="block-component"
            />third parties. Learn more about&nbsp;</span></span><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            >when and with whom we share your personal information</span></span><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text">.<span
              class="block-component"
            /></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><strong>How do we keep your information safe?</strong> We have <span
              class="block-component"
            />organizational<span class="statement-end-if-in-editor" /> and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other <span
              class="block-component"
            />unauthorized<span class="statement-end-if-in-editor" /> third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Learn more about&nbsp;</span></span><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            >how we keep your information safe</span></span><span
              data-custom-class="body_text"
            >.</span><span style="font-size: 15px;"><span data-custom-class="body_text"><span
              class="statement-end-if-in-editor"
            /></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><strong>What are your rights?</strong> Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information. Learn more about&nbsp;</span></span><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            >your privacy rights</span></span><span
              data-custom-class="body_text"
            >.</span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><strong>How do you exercise your rights?</strong> The easiest way to exercise your rights is by <span
              class="block-component"
            />visiting <span class="question">sda@reserverm.com</span><span
              class="else-block"
            />, or by contacting us. We will consider and act upon any request in accordance with applicable data protection laws.</span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text">Want to learn more about what we do with any information we collect?&nbsp;</span></span><span style="font-size: 15px;"><span data-custom-class="body_text">Review the privacy notice in full</span></span><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text">.</span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div
            id="toc"
            style="line-height: 1.5;"
          >
            <span style="font-size: 15px;"><span
              style="color: rgb(127, 127, 127);"
            ><span style="color: rgb(0, 0, 0);"><strong><span
              data-custom-class="heading_1"
            >TABLE OF CONTENTS</span></strong></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span
              style="color: rgb(89, 89, 89);"
            >1. WHAT INFORMATION DO WE COLLECT?</span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span
              style="color: rgb(89, 89, 89);"
            >2. HOW DO WE PROCESS YOUR INFORMATION?<span class="block-component" /></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);">3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span><span
              data-custom-class="body_text"
            ><span class="block-component" /></span><span
              style="color: rgb(127, 127, 127);"
            ><span style="color: rgb(89, 89, 89);"><span
              data-custom-class="body_text"
            ><span style="color: rgb(89, 89, 89);"><span
              class="block-component"
            /></span></span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span
              style="color: rgb(89, 89, 89);"
            >4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</span><span
              style="color: rgb(127, 127, 127);"
            ><span style="color: rgb(89, 89, 89);"><span
              data-custom-class="body_text"
            ><span style="color: rgb(89, 89, 89);"><span
              class="statement-end-if-in-editor"
            /></span></span><span data-custom-class="body_text"><span
              style="color: rgb(89, 89, 89);"
            ><span style="color: rgb(89, 89, 89);"><span
              style="color: rgb(89, 89, 89);"
            ><span class="block-component" /></span></span><span
              class="block-component"
            /></span></span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span
              style="color: rgb(89, 89, 89);"
            >5. HOW LONG DO WE KEEP YOUR INFORMATION?</span><span
              style="color: rgb(127, 127, 127);"
            ><span style="color: rgb(89, 89, 89);"><span
              data-custom-class="body_text"
            ><span style="color: rgb(89, 89, 89);"><span style="color: rgb(89, 89, 89);"><span
              class="block-component"
            /></span></span></span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span
              style="color: rgb(89, 89, 89);"
            >6. HOW DO WE KEEP YOUR INFORMATION SAFE?</span><span
              style="color: rgb(127, 127, 127);"
            ><span style="color: rgb(89, 89, 89);"><span
              data-custom-class="body_text"
            ><span style="color: rgb(89, 89, 89);"><span
              class="statement-end-if-in-editor"
            /><span
              class="block-component"
            /></span></span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span
              style="color: rgb(89, 89, 89);"
            >7. DO WE COLLECT INFORMATION FROM MINORS?</span><span
              style="color: rgb(127, 127, 127);"
            ><span style="color: rgb(89, 89, 89);"><span
              data-custom-class="body_text"
            ><span style="color: rgb(89, 89, 89);"><span
              class="statement-end-if-in-editor"
            /></span></span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);">8. WHAT ARE YOUR PRIVACY RIGHTS?</span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span
              style="color: rgb(89, 89, 89);"
            >9. CONTROLS FOR DO-NOT-TRACK FEATURES</span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span
              style="color: rgb(89, 89, 89);"
            >10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span></span>
            <span class="block-component"><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            /></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;">11. DO VIRGINIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span><span
              style="font-size: 15px;"
            ><span class="statement-end-if-in-editor"><span
              data-custom-class="body_text"
            /></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span class="block-component"><span style="font-size: 15px;" /></span>
            <span class="block-component" />
            <span class="block-component" />
            <span class="block-component" />
            <span class="block-component" />
            <span class="block-component" />
            <span class="block-component" />
            <span class="block-component" />
            <span class="block-component" />
            <span class="block-component" />
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span
              style="color: rgb(89, 89, 89);"
            >12. DO WE MAKE UPDATES TO THIS NOTICE?</span></span>
          </div>
          <div style="line-height: 1.5;">
            <span
              style="color: rgb(89, 89, 89); font-size: 15px;"
            >13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span>
          </div>
          <div style="line-height: 1.5;">
            <span
              style="color: rgb(89, 89, 89);"
            >14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div
            id="infocollect"
            style="line-height: 1.5;"
          >
            <span style="color: rgb(127, 127, 127);"><span
              style="color: rgb(89, 89, 89); font-size: 15px;"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              id="control"
              style="color: rgb(0, 0, 0);"
            ><strong><span
              data-custom-class="heading_1"
            >1. WHAT INFORMATION DO WE COLLECT?</span></strong></span></span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div
            id="personalinfo"
            style="line-height: 1.5;"
          >
            <span
              data-custom-class="heading_2"
              style="color: rgb(0, 0, 0);"
            ><span
              style="font-size: 15px;"
            ><strong>Personal information you disclose to us</strong></span></span>
          </div>
          <div>
            <div><br></div>
            <div style="line-height: 1.5;">
              <span style="color: rgb(127, 127, 127);"><span
                style="color: rgb(89, 89, 89); font-size: 15px;"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                data-custom-class="body_text"
              ><strong><em>In Short:</em></strong></span></span></span></span><span
                data-custom-class="body_text"
              ><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span
                data-custom-class="body_text"
              ><strong><em>&nbsp;</em></strong><em>We collect personal information that you provide to us.</em></span></span></span></span></span></span>
            </div>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text">We collect personal information that you voluntarily provide to us when you <span
              style="font-size: 15px;"
            ><span
              class="block-component"
            /></span>register on the Services,&nbsp;</span><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            ><span style="font-size: 15px;"><span
              class="statement-end-if-in-editor"
            /></span></span><span data-custom-class="body_text">express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.</span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span class="block-component" /></span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><strong>Personal Information Provided by You.</strong> The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:<span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span
                class="question"
              >names</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span
                class="question"
              >phone numbers</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span class="question">email addresses</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span
                class="question"
              >job titles</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span
                class="question"
              >contact preferences</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span
                class="question"
              >billing addresses</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span class="question">debit/credit card numbers</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span class="question">contact or authentication data</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span
                class="question"
              >passwords</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="forloop-component" /></span></span></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span data-custom-class="body_text"><span
                class="question"
              >mailing addresses</span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span
              class="forloop-component"
            /></span><span data-custom-class="body_text"><span
              class="statement-end-if-in-editor"
            /></span></span></span></span></span>
          </div>
          <div
            id="sensitiveinfo"
            style="line-height: 1.5;"
          >
            <span style="font-size: 15px;"><span
              data-custom-class="body_text"
            ><strong>Sensitive Information.</strong> <span class="block-component" />We do not process sensitive information.</span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text"><span
              class="else-block"
            /></span></span><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              data-custom-class="body_text"
            ><strong>Payment Data.</strong> We may collect data necessary to process your payment if you make purchases, such as your payment instrument number, and the security code associated with your payment instrument. All payment data is stored by<span
              class="forloop-component"
            /><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span></span></span> <span class="question">Stripe</span><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
              style="color: rgb(89, 89, 89);"
            ><span style="font-size: 15px;"><span data-custom-class="body_text"><span
              class="forloop-component"
            /></span></span></span></span></span></span></span></span></span></span></span></span>. You may find their privacy notice link(s) here:<span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              class="forloop-component"
            /><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span></span></span></span></span></span> <span
              class="question"
            ><a
              href="https://stripe.com/privacy"
              target="_blank"
            >https://stripe.com/privacy</a></span><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span></span></span></span></span></span><span
              class="forloop-component"
            /><span style="font-size: 15px;"><span data-custom-class="body_text">.<span
              class="block-component"
            /></span></span></span></span></span></span></span></span></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span class="statement-end-if-in-editor"><span
              class="block-component"
            /></span></span></span></span></span><span class="block-component"> <span
              class="block-component"
            /></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span data-custom-class="body_text"><span style="font-size: 15px;"><strong>Application Data.</strong> If you use our application(s), we also may collect the following information if you choose to provide us with access or permission:<span
              class="block-component"
            /></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span data-custom-class="body_text"><span style="font-size: 15px;"><em>Geolocation Information.</em> We may request access or permission to track location-based information from your mobile device, either continuously or while you are using our mobile application(s), to provide certain location-based services. If you wish to change our access or permissions, you may do so in your device's settings.<span
                class="statement-end-if-in-editor"
              /></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span class="block-component"><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            /></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px;"><span data-custom-class="body_text"><em>Mobile Device Access.</em> We may request access or permission to certain features from your mobile device, including your mobile device's <span
                class="forloop-component"
              /><span class="question">camera</span>, <span
                class="forloop-component"
              /><span class="question">reminders</span>, <span
                class="forloop-component"
              /><span class="question">sms messages</span>, <span
                class="forloop-component"
              />and other features. If you wish to change our access or permissions, you may do so in your device's settings.<span
                class="statement-end-if-in-editor"
              /></span></span>
            </li>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px;"><span data-custom-class="body_text"><em>Text Messaging.</em> If you opt in to RM AI text messaging, we use your mobile number to send and receive those messages. Mobile numbers, text messaging originator opt-in data and consent will not be shared with or sold to third parties or affiliates for marketing or promotional purposes.</span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span class="block-component"><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            /></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px;"><span data-custom-class="body_text"><em>Mobile Device Data.</em> We automatically collect device information (such as your mobile device ID, model, and manufacturer), operating system, version information and system configuration information, device and application identification numbers, browser type and version, hardware model Internet service provider and/or mobile carrier, and Internet Protocol (IP) address (or proxy server). If you are using our application(s), we may also collect information about the phone network associated with your mobile device, your mobile device’s operating system or platform, the type of mobile device you use, your mobile device’s unique device ID, and information about the features of our application(s) you accessed.<span
                class="statement-end-if-in-editor"
              /></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span class="block-component"><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            /></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px;"><span data-custom-class="body_text"><em>Push Notifications.</em> We may request to send you push notifications regarding your account or certain features of the application(s). If you wish to opt out from receiving these types of communications, you may turn them off in your device's settings.<span
                class="statement-end-if-in-editor"
              /></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px;"><span data-custom-class="body_text">This information is primarily needed to maintain the security and operation of our application(s), for troubleshooting, and for our internal analytics and reporting purposes.</span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span class="statement-end-if-in-editor"><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            /></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text">All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.</span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span
              data-custom-class="heading_2"
              style="color: rgb(0, 0, 0);"
            ><span
              style="font-size: 15px;"
            ><strong>Information automatically collected</strong></span></span>
          </div>
          <div>
            <div><br></div>
            <div style="line-height: 1.5;">
              <span style="color: rgb(127, 127, 127);"><span
                style="color: rgb(89, 89, 89); font-size: 15px;"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                data-custom-class="body_text"
              ><strong><em>In Short:</em></strong></span></span></span></span><span
                data-custom-class="body_text"
              ><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span
                data-custom-class="body_text"
              ><strong><em>&nbsp;</em></strong><em>Some information — such as your Internet Protocol (IP) address and/or browser and device characteristics — is collected automatically when you visit our Services.</em></span></span></span></span></span></span>
            </div>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text">We automatically collect certain information when you visit, use, or navigate the Services. This information does not reveal your specific identity (like your name or contact information) but may include device and usage information, such as your IP address, browser and device characteristics, operating system, language preferences, referring URLs, device name, country, location, information about how and when you use our Services, and other technical information. This information is primarily needed to maintain the security and operation of our Services, and for our internal analytics and reporting purposes.</span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text">Like many businesses, we also collect information through cookies and similar technologies. <span
              class="block-component"
            />You can find out more about this in our Cookie Notice: <span
              class="statement-end-if-in-editor"
            /><span class="block-component" /><span class="question"><a
              href="https://reserverm.com/cookie"
              target="_blank"
            >https://reserverm.com/cookie</a></span>.<span
              class="statement-end-if-in-editor"
            /></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              class="statement-end-if-in-editor"
            ><span data-custom-class="body_text" /></span></span><span
              data-custom-class="body_text"
            ><span class="block-component" /></span></span></span>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text">The information we collect includes:<span
              class="block-component"
            /></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><em>Log and Usage Data.</em> Log and usage data is service-related, diagnostic, usage, and performance information our servers automatically collect when you access or use our Services and which we record in log files. Depending on how you interact with us, this log data may include your IP address, device information, browser type, and settings and information about your activity in the Services<span
                style="font-size: 15px;"
              >&nbsp;</span>(such as the date/time stamps associated with your usage, pages and files viewed, searches, and other actions you take such as which features you use), device event information (such as system activity, error reports (sometimes called <span
                class="block-component"
              />"crash dumps"<span class="statement-end-if-in-editor" />), and hardware settings).<span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span
                class="statement-end-if-in-editor"
              /></span></span></span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span class="block-component"><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            /></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span
                data-custom-class="body_text"
              ><em>Device Data.</em> We collect device data such as information about your computer, phone, tablet, or other device you use to access the Services. Depending on the device used, this device data may include information such as your IP address (or proxy server), device and application identification numbers, location, browser type, hardware model, Internet service provider and/or mobile carrier, operating system, and system configuration information.<span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span
                class="statement-end-if-in-editor"
              /></span></span></span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span class="block-component"><span style="font-size: 15px;"><span
              data-custom-class="body_text"
            /></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span
                data-custom-class="body_text"
              ><em>Location Data.</em> We collect location data such as information about your device's location, which can be either precise or imprecise. How much information we collect depends on the type and settings of the device you use to access the Services. For example, we may use GPS and other technologies to collect geolocation data that tells us your current location (based on your IP address). You can opt out of allowing us to collect this information either by refusing access to the information or by disabling your Location setting on your device. However, if you choose to opt out, you may not be able to use certain aspects of the Services.<span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span
                class="statement-end-if-in-editor"
              /></span></span></span></span></span></span></span></span>
            </li>
          </ul>
          <div>
            <span class="block-component"><span style="font-size: 15px;" /></span>
            <span class="statement-end-if-in-editor" />
            <span data-custom-class="body_text"><span style="color: rgb(89, 89, 89); font-size: 15px;"><span
              data-custom-class="body_text"
            ><span style="color: rgb(89, 89, 89); font-size: 15px;"><span
              data-custom-class="body_text"
            ><span class="statement-end-if-in-editor"><span
              class="block-component"
            /></span></span></span></span></span></span><span
              style="font-size: 15px;"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span>
          </div>
          <div
            id="infouse"
            style="line-height: 1.5;"
          >
            <span style="color: rgb(127, 127, 127);"><span
              style="color: rgb(89, 89, 89); font-size: 15px;"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span
              id="control"
              style="color: rgb(0, 0, 0);"
            ><strong><span
              data-custom-class="heading_1"
            >2. HOW DO WE PROCESS YOUR INFORMATION?</span></strong></span></span></span></span></span>
          </div>
          <div>
            <div style="line-height: 1.5;">
              <br>
            </div>
            <div style="line-height: 1.5;">
              <span style="color: rgb(127, 127, 127);"><span
                style="color: rgb(89, 89, 89); font-size: 15px;"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                data-custom-class="body_text"
              ><strong><em>In Short:&nbsp;</em></strong><em>We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent.</em></span></span></span></span></span></span>
            </div>
          </div>
          <div style="line-height: 1.5;">
            <br>
          </div>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><strong>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</strong><span
              class="block-component"
            /></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><strong>To facilitate account creation and authentication and otherwise manage user accounts.&nbsp;</strong>We may process your information so you can create and log in to your account, as well as keep your account in working order.<span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                data-custom-class="body_text"
              ><span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span
                data-custom-class="body_text"
              ><span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span
                data-custom-class="body_text"
              ><span class="statement-end-if-in-editor" /></span></span></span></span></span></span></span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span>
          </div>
          <ul>
            <li style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><strong>To deliver and facilitate delivery of services to the user.&nbsp;</strong>We may process your information to provide you with the requested service.<span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                data-custom-class="body_text"
              ><span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
                style="font-size: 15px;"
              ><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text"><span
                class="statement-end-if-in-editor"
              /></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span>
            </li>
          </ul>
          <div style="line-height: 1.5;">
            <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
              style="font-size: 15px; color: rgb(89, 89, 89);"
            ><span data-custom-class="body_text"><span
              class="block-component"
            /></span></span></span>
            <div style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                class="block-component"
              /></span></span></span>
            </div>
            <ul>
              <li style="line-height: 1.5;">
                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                  style="font-size: 15px; color: rgb(89, 89, 89);"
                ><span data-custom-class="body_text"><strong>To respond to user inquiries/offer support to users.&nbsp;</strong>We may process your information to respond to your inquiries and solve any potential issues you might have with the requested service.<span
                  style="font-size: 15px; color: rgb(89, 89, 89);"
                ><span
                  style="font-size: 15px; color: rgb(89, 89, 89);"
                ><span data-custom-class="body_text"><span
                  style="font-size: 15px;"
                ><span style="color: rgb(89, 89, 89);"><span
                  data-custom-class="body_text"
                ><span style="font-size: 15px;"><span
                  style="color: rgb(89, 89, 89);"
                ><span data-custom-class="body_text"><span
                  class="statement-end-if-in-editor"
                /></span></span></span></span></span></span></span></span></span></span></span></span>
              </li>
            </ul>
            <div style="line-height: 1.5;">
              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                style="font-size: 15px; color: rgb(89, 89, 89);"
              ><span data-custom-class="body_text"><span
                class="block-component"
              /></span></span></span>
              <div style="line-height: 1.5;">
                <span class="block-component"><span style="font-size: 15px;" /></span>
                <div style="line-height: 1.5;">
                  <span class="block-component"><span style="font-size: 15px;" /></span>
                  <div style="line-height: 1.5;">
                    <span class="block-component"><span style="font-size: 15px;" /></span>
                  </div>
                  <ul>
                    <li style="line-height: 1.5;">
                      <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                        style="font-size: 15px; color: rgb(89, 89, 89);"
                      ><span data-custom-class="body_text"><strong>To <span
                        class="block-component"
                      />fulfill<span class="statement-end-if-in-editor" /> and manage your orders.&nbsp;</strong>We may process your information to <span
                        class="block-component"
                      />fulfill<span class="statement-end-if-in-editor" /> and manage your orders, payments, returns, and exchanges made through the Services.<span
                        style="font-size: 15px; color: rgb(89, 89, 89);"
                      ><span
                        style="font-size: 15px; color: rgb(89, 89, 89);"
                      ><span data-custom-class="body_text"><span
                        style="font-size: 15px; color: rgb(89, 89, 89);"
                      ><span
                        style="font-size: 15px; color: rgb(89, 89, 89);"
                      ><span data-custom-class="body_text"><span
                        style="font-size: 15px; color: rgb(89, 89, 89);"
                      ><span
                        style="font-size: 15px; color: rgb(89, 89, 89);"
                      ><span data-custom-class="body_text"><span
                        class="statement-end-if-in-editor"
                      /></span></span></span></span></span></span></span></span></span></span></span></span>
                    </li>
                  </ul>
                  <div style="line-height: 1.5;">
                    <span class="block-component"><span style="font-size: 15px;"><span
                      data-custom-class="body_text"
                    /></span></span>
                    <p style="font-size: 15px; line-height: 1.5;">
                      <span class="block-component"><span style="font-size: 15px;" /></span>
                    </p>
                    <p style="font-size: 15px; line-height: 1.5;">
                      <span class="block-component"><span style="font-size: 15px;" /></span>
                    </p>
                    <p style="font-size: 15px; line-height: 1.5;">
                      <span class="block-component" />
                    </p>
                    <ul>
                      <li style="line-height: 1.5;">
                        <span style="font-size: 15px;"><span
                          style="color: rgb(89, 89, 89);"
                        ><span style="color: rgb(89, 89, 89);"><span
                          data-custom-class="body_text"
                        ><strong>To request feedback.&nbsp;</strong>We may process your information when necessary to request feedback and to contact you about your use of our Services.<span
                          style="color: rgb(89, 89, 89);"
                        ><span style="color: rgb(89, 89, 89);"><span
                          data-custom-class="body_text"
                        ><span style="color: rgb(89, 89, 89);"><span
                          data-custom-class="body_text"
                        ><span style="color: rgb(89, 89, 89);"><span
                          data-custom-class="body_text"
                        ><span
                          class="statement-end-if-in-editor"
                        /></span></span></span></span></span></span></span></span></span></span></span>
                      </li>
                    </ul>
                    <p style="font-size: 15px; line-height: 1.5;">
                      <span class="block-component" />
                    </p>
                    <div style="line-height: 1.5;">
                      <span class="block-component"><span style="font-size: 15px;"><span
                        data-custom-class="body_text"
                      /></span></span>
                      <div style="line-height: 1.5;">
                        <span class="block-component"><span style="font-size: 15px;" /></span>
                        <div style="line-height: 1.5;">
                          <span class="block-component"><span style="font-size: 15px;" /></span>
                          <div style="line-height: 1.5;">
                            <span style="font-size: 15px;"><span
                              class="block-component"
                            ><span data-custom-class="body_text" /></span></span>
                            <div style="line-height: 1.5;">
                              <span class="block-component"><span style="font-size: 15px;"><span
                                data-custom-class="body_text"
                              /></span></span>
                            </div>
                            <ul>
                              <li style="line-height: 1.5;">
                                <span style="font-size: 15px;"><span
                                  data-custom-class="body_text"
                                ><strong>To post testimonials.</strong> We post testimonials on our Services that may contain personal information.<span
                                  class="statement-end-if-in-editor"
                                /></span></span>
                              </li>
                            </ul>
                            <div style="line-height: 1.5;">
                              <span class="block-component"><span style="font-size: 15px;"><span
                                data-custom-class="body_text"
                              /></span></span>
                            </div>
                            <ul>
                              <li style="line-height: 1.5;">
                                <span data-custom-class="body_text"><span
                                  style="font-size: 15px;"
                                ><strong>To protect our Services.</strong> We may process your information as part of our efforts to keep our Services safe and secure, including fraud monitoring and prevention.</span></span>
                                <span class="statement-end-if-in-editor"><span style="font-size: 15px;"><span
                                  data-custom-class="body_text"
                                /></span></span>
                              </li>
                            </ul>
                            <div style="line-height: 1.5;">
                              <span class="block-component"><span style="font-size: 15px;"><span
                                data-custom-class="body_text"
                              /></span></span>
                              <div style="line-height: 1.5;">
                                <span class="block-component"><span style="font-size: 15px;"><span
                                  data-custom-class="body_text"
                                /></span></span>
                                <div style="line-height: 1.5;">
                                  <span class="block-component"><span style="font-size: 15px;"><span
                                    data-custom-class="body_text"
                                  /></span></span>
                                </div>
                                <ul>
                                  <li style="line-height: 1.5;">
                                    <span data-custom-class="body_text"><span
                                      style="font-size: 15px;"
                                    ><strong>To evaluate and improve our Services, products, marketing, and your experience.</strong> We may process your information when we believe it is necessary to identify usage trends, determine the effectiveness of our promotional campaigns, and to evaluate and improve our Services, products, marketing, and your experience.</span></span>
                                    <span class="statement-end-if-in-editor"><span style="font-size: 15px;"><span
                                      data-custom-class="body_text"
                                    /></span></span>
                                  </li>
                                </ul>
                                <div style="line-height: 1.5;">
                                  <span class="block-component"><span style="font-size: 15px;"><span
                                    data-custom-class="body_text"
                                  /></span></span>
                                </div>
                                <ul>
                                  <li style="line-height: 1.5;">
                                    <span data-custom-class="body_text"><span
                                      style="font-size: 15px;"
                                    ><strong>To identify usage trends.</strong> We may process information about how you use our Services to better understand how they are being used so we can improve them.</span></span>
                                    <span class="statement-end-if-in-editor"><span style="font-size: 15px;"><span
                                      data-custom-class="body_text"
                                    /></span></span>
                                  </li>
                                </ul>
                                <div style="line-height: 1.5;">
                                  <span class="block-component"><span style="font-size: 15px;"><span
                                    data-custom-class="body_text"
                                  /></span></span>
                                  <div style="line-height: 1.5;">
                                    <span class="block-component"><span style="font-size: 15px;"><span
                                      data-custom-class="body_text"
                                    /></span></span>
                                    <div style="line-height: 1.5;">
                                      <span class="block-component"><span style="font-size: 15px;"><span
                                        data-custom-class="body_text"
                                      /></span></span>
                                      <div style="line-height: 1.5;">
                                        <span class="block-component"><span style="font-size: 15px;"><span
                                          data-custom-class="body_text"
                                        /></span></span>
                                      </div>
                                      <ul>
                                        <li style="line-height: 1.5;">
                                          <span style="font-size: 15px;"><span
                                            data-custom-class="body_text"
                                          ><strong>To comply with our legal obligations.</strong> We may process your information to comply with our legal obligations, respond to legal requests, and exercise, establish, or defend our legal rights.<span
                                            class="statement-end-if-in-editor"
                                          /></span></span>
                                        </li>
                                      </ul>
                                      <div style="line-height: 1.5;">
                                        <span class="block-component"><span style="font-size: 15px;"><span
                                          data-custom-class="body_text"
                                        /></span></span>
                                        <div style="line-height: 1.5;">
                                          <span class="block-component"><span style="font-size: 15px;"><span
                                            data-custom-class="body_text"
                                          /></span></span>
                                          <span class="block-component"><span style="font-size: 15px;"><span
                                            data-custom-class="body_text"
                                          /></span></span>
                                          <span class="block-component"><span style="font-size: 15px;"><span
                                            data-custom-class="body_text"
                                          /></span></span>
                                          <span class="block-component"><span style="font-size: 15px;"><span
                                            data-custom-class="body_text"
                                          /></span></span>
                                        </div>
                                        <div style="line-height: 1.5;">
                                          <br>
                                        </div>
                                        <div
                                          id="whoshare"
                                          style="line-height: 1.5;"
                                        >
                                          <span
                                            style="color: rgb(127, 127, 127);"
                                          ><span
                                            style="color: rgb(89, 89, 89); font-size: 15px;"
                                          ><span
                                            style="font-size: 15px; color: rgb(89, 89, 89);"
                                          ><span
                                            style="font-size: 15px; color: rgb(89, 89, 89);"
                                          ><span
                                            id="control"
                                            style="color: rgb(0, 0, 0);"
                                          ><strong><span
                                            data-custom-class="heading_1"
                                          >3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</span></strong></span></span></span></span></span>
                                        </div>
                                        <div style="line-height: 1.5;">
                                          <br>
                                        </div>
                                        <div style="line-height: 1.5;">
                                          <span
                                            style="font-size: 15px; color: rgb(89, 89, 89);"
                                          ><span
                                            style="font-size: 15px; color: rgb(89, 89, 89);"
                                          ><span
                                            data-custom-class="body_text"
                                          ><strong><em>In Short:</em></strong><em>&nbsp;We may share information in specific situations described in this section and/or with the following <span
                                            class="block-component"
                                          />third parties.</em></span></span></span>
                                        </div>
                                        <div style="line-height: 1.5;">
                                          <span
                                            style="font-size: 15px; color: rgb(89, 89, 89);"
                                          ><span
                                            style="font-size: 15px; color: rgb(89, 89, 89);"
                                          ><span
                                            data-custom-class="body_text"
                                          ><span
                                            class="block-component"
                                          /></span></span></span>
                                        </div>
                                        <div style="line-height: 1.5;">
                                          <br>
                                        </div>
                                        <div style="line-height: 1.5;">
                                          <span style="font-size: 15px;"><span
                                            data-custom-class="body_text"
                                          >We <span class="block-component" />may need to share your personal information in the following situations:</span></span>
                                        </div>
                                        <ul>
                                          <li style="line-height: 1.5;">
                                            <span style="font-size: 15px;"><span
                                              data-custom-class="body_text"
                                            ><strong>Your Profile.</strong> Upon account creation, a basic profile will be automatically generated for you, which includes a unique URL set by you, making it accessible on the web and searchable by our members. This profile typically showcases your profile image, name, professional title, company, and a brief biography. It's important to understand that this information is not just visible to app users but to anyone with the profile URL. For members who wish to expand their visibility, we offer the flexibility to switch your profile settings from private to public. A public profile enables the sharing of additional personal details, such as your dining preferences and activities. We are committed to your privacy and ensure you have complete control over the information you choose to share. At any point, you can adjust your privacy settings to manage the extent of your profile's visibility on the internet.</span></span>
                                          </li>
                                        </ul>
                                        <ul>
                                          <li style="line-height: 1.5;">
                                            <span style="font-size: 15px;"><span
                                              data-custom-class="body_text"
                                            ><strong>Restaurants.</strong> When you make a request though our system we share personal information about you. This is to help facilitate your request and improve your chances of getting a reservation</span></span>
                                          </li>
                                        </ul>
                                        <ul>
                                          <li style="line-height: 1.5;">
                                            <span style="font-size: 15px;"><span
                                              data-custom-class="body_text"
                                            ><strong>Business Transfers.</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.</span></span>
                                          </li>
                                        </ul>
                                        <div style="line-height: 1.5;">
                                          <span style="font-size: 15px;"><span
                                            data-custom-class="body_text"
                                          ><span
                                            class="block-component"
                                          /></span></span>
                                        </div>
                                        <ul>
                                          <li style="line-height: 1.5;">
                                            <span style="font-size: 15px;"><span
                                              data-custom-class="body_text"
                                            ><strong>When we use Google Maps Platform APIs.</strong> We may share your information with certain Google Maps Platform APIs (e.g.<span
                                              class="block-component"
                                            />,<span
                                              class="statement-end-if-in-editor"
                                            /> Google Maps API, Places API).</span><span
                                              data-custom-class="body_text"
                                            ><span class="block-component" /><span
                                              class="block-component"
                                            /> We obtain and store on your device (<span
                                              class="block-component"
                                            />"cache"<span
                                              class="statement-end-if-in-editor"
                                            />) your location<span
                                              class="block-component"
                                            />. The <a
                                              href="http://www.google.com/policies/privacy"
                                              target="_blank"
                                            >Google Privacy Policy can be found here</a>. You may revoke your consent anytime by contacting us at the contact details provided at the end of this document.<span
                                              class="statement-end-if-in-editor"
                                            /><span
                                              class="block-component"
                                            /></span></span>
                                          </li>
                                        </ul>
                                        <div style="line-height: 1.5;">
                                          <span style="font-size: 15px;"><span
                                            class="block-component"
                                          ><span
                                            data-custom-class="body_text"
                                          /></span></span>
                                        </div>
                                        <ul>
                                          <li style="line-height: 1.5;">
                                            <span style="font-size: 15px;"><span
                                              data-custom-class="body_text"
                                            ><strong>Affiliates.&nbsp;</strong>We may share your information with our affiliates, in which case we will require those affiliates to <span
                                              class="block-component"
                                            />honor<span
                                              class="statement-end-if-in-editor"
                                            /> this privacy notice. Affiliates include our parent company and any subsidiaries, joint venture partners, or other companies that we control or that are under common control with us.</span><span
                                              class="statement-end-if-in-editor"
                                            ><span
                                              data-custom-class="body_text"
                                            /></span></span>
                                          </li>
                                        </ul>
                                        <div style="line-height: 1.5;">
                                          <span class="block-component"><span style="font-size: 15px;"><span
                                            data-custom-class="body_text"
                                          /></span></span>
                                        </div>
                                        <ul>
                                          <li style="line-height: 1.5;">
                                            <span data-custom-class="body_text"><span
                                              style="font-size: 15px;"
                                            ><strong>Business Partners.</strong> We may share your information with our business partners to offer you certain products, services, or promotions.</span></span>
                                            <span class="statement-end-if-in-editor"><span style="font-size: 15px;"><span
                                              data-custom-class="body_text"
                                            /></span></span>
                                          </li>
                                        </ul>
                                        <div style="line-height: 1.5;">
                                          <span class="block-component"><span style="font-size: 15px;"><span
                                            data-custom-class="body_text"
                                          /></span></span>
                                          <div style="line-height: 1.5;">
                                            <span class="block-component"><span style="font-size: 15px;"><span
                                              data-custom-class="body_text"
                                            /></span></span>
                                            <span data-custom-class="body_text"><span style="font-size: 15px;"><span
                                              class="block-component"
                                            /></span></span>
                                            <span class="statement-end-if-in-editor"><span style="font-size: 15px;"><span
                                              data-custom-class="body_text"
                                            /></span></span>
                                            <div style="line-height: 1.5;">
                                              <span class="block-component"><span style="font-size: 15px;"><span
                                                data-custom-class="body_text"
                                              /></span></span>
                                              <span style="color: rgb(89, 89, 89); font-size: 15px;"><span
                                                style="font-size: 15px;"
                                              ><span style="color: rgb(89, 89, 89);"><span
                                                style="font-size: 15px;"
                                              ><span style="color: rgb(89, 89, 89);"><span
                                                class="block-component"
                                              ><span
                                                data-custom-class="heading_1"
                                              /></span></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div
                                              id="cookies"
                                              style="line-height: 1.5;"
                                            >
                                              <span
                                                style="color: rgb(127, 127, 127);"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                id="control"
                                                style="color: rgb(0, 0, 0);"
                                              ><strong><span
                                                data-custom-class="heading_1"
                                              >4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</span></strong></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><strong><em>In Short:</em></strong><em>&nbsp;We may use cookies and other tracking technologies to collect and store your information.</em></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store information. Specific information about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Notice<span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                data-custom-class="body_text"
                                              ><span class="block-component" />: <span
                                                class="question"
                                              ><a
                                                href="https://reserverm.com/cookie"
                                                target="_blank"
                                              >https://reserverm.com/cookie</a></span></span><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                data-custom-class="body_text"
                                              ><span
                                                class="statement-end-if-in-editor"
                                              />.</span><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="font-size: 15px;"
                                              ><span style="color: rgb(89, 89, 89);"><span
                                                style="font-size: 15px;"
                                              ><span style="color: rgb(89, 89, 89);"><span
                                                data-custom-class="body_text"
                                              ><span
                                                class="statement-end-if-in-editor"
                                              /></span></span></span></span></span></span></span></span><span
                                                data-custom-class="body_text"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="font-size: 15px;"
                                              ><span style="color: rgb(89, 89, 89);"><span
                                                style="font-size: 15px;"
                                              ><span style="color: rgb(89, 89, 89);"><span
                                                data-custom-class="body_text"
                                              ><span class="block-component" /></span><span
                                                class="block-component"
                                              ><span data-custom-class="body_text"><span
                                                class="block-component"
                                              /></span></span></span></span></span></span></span></span></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div
                                              id="inforetain"
                                              style="line-height: 1.5;"
                                            >
                                              <span
                                                style="color: rgb(127, 127, 127);"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                id="control"
                                                style="color: rgb(0, 0, 0);"
                                              ><strong><span
                                                data-custom-class="heading_1"
                                              >5. HOW LONG DO WE KEEP YOUR INFORMATION?</span></strong></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><strong><em>In Short:&nbsp;</em></strong><em>We keep your information for as long as necessary to <span
                                                class="block-component"
                                              />fulfill<span
                                                class="statement-end-if-in-editor"
                                              /> the purposes outlined in this privacy notice unless otherwise required by law.</em></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements).<span
                                                class="block-component"
                                              /> No purpose in this notice will require us keeping your personal information for longer than <span
                                                style="font-size: 15px;"
                                              ><span style="color: rgb(89, 89, 89);"><span
                                                data-custom-class="body_text"
                                              ><span class="block-component" /></span></span></span><span
                                                class="block-component"
                                              /><span
                                                class="question"
                                              >twenty four (24)</span> months past the termination of the user's account<span
                                                class="block-component"
                                              /><span style="font-size: 15px;"><span
                                                style="color: rgb(89, 89, 89);"
                                              ><span data-custom-class="body_text"><span
                                                class="else-block"
                                              /></span></span></span>.</span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >When we have no ongoing legitimate business need to process your personal information, we will either delete or <span
                                                class="block-component"
                                              />anonymize<span
                                                class="statement-end-if-in-editor"
                                              /> such information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.<span
                                                style="color: rgb(89, 89, 89);"
                                              ><span
                                                class="block-component"
                                              /></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div
                                              id="infosafe"
                                              style="line-height: 1.5;"
                                            >
                                              <span
                                                style="color: rgb(127, 127, 127);"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                id="control"
                                                style="color: rgb(0, 0, 0);"
                                              ><strong><span
                                                data-custom-class="heading_1"
                                              >6. HOW DO WE KEEP YOUR INFORMATION SAFE?</span></strong></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><strong><em>In Short:&nbsp;</em></strong><em>We aim to protect your personal information through a system of <span
                                                class="block-component"
                                              />organizational<span
                                                class="statement-end-if-in-editor"
                                              /> and technical security measures.</em></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >We have implemented appropriate and reasonable technical and <span
                                                class="block-component"
                                              />organizational<span
                                                class="statement-end-if-in-editor"
                                              /> security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other <span
                                                class="block-component"
                                              />unauthorized<span
                                                class="statement-end-if-in-editor"
                                              /> third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your own risk. You should only access the Services within a secure environment.<span
                                                style="color: rgb(89, 89, 89);"
                                              ><span
                                                class="statement-end-if-in-editor"
                                              /></span><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                data-custom-class="body_text"
                                              ><span class="block-component" /></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div
                                              id="infominors"
                                              style="line-height: 1.5;"
                                            >
                                              <span
                                                style="color: rgb(127, 127, 127);"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                id="control"
                                                style="color: rgb(0, 0, 0);"
                                              ><strong><span
                                                data-custom-class="heading_1"
                                              >7. DO WE COLLECT INFORMATION FROM MINORS?</span></strong></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><strong><em>In Short:</em></strong><em>&nbsp;We do not knowingly collect data from or market to <span
                                                class="block-component"
                                              />children under 18 years of age<span
                                                class="else-block"
                                              />.</em><span
                                                class="block-component"
                                              /></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >We do not knowingly solicit data from or market to children under 18 years of age. By using the Services, you represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to such minor dependent’s use of the Services. If we learn that personal information from users less than 18 years of age has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we may have collected from children under age 18, please contact us at <span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                data-custom-class="body_text"
                                              ><span class="block-component" /><span
                                                class="question"
                                              >privacy@reserevrm.com</span><span
                                                class="else-block"
                                              /></span></span>.</span><span
                                                data-custom-class="body_text"
                                              ><span class="else-block"><span
                                                class="block-component"
                                              /></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div
                                              id="privacyrights"
                                              style="line-height: 1.5;"
                                            >
                                              <span
                                                style="color: rgb(127, 127, 127);"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                id="control"
                                                style="color: rgb(0, 0, 0);"
                                              ><strong><span
                                                data-custom-class="heading_1"
                                              >8. WHAT ARE YOUR PRIVACY RIGHTS?</span></strong></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><strong><em>In Short:</em></strong><em>&nbsp;<span
                                                style="color: rgb(89, 89, 89);"
                                              ><span style="font-size: 15px;"><span
                                                data-custom-class="body_text"
                                              ><em><span
                                                class="block-component"
                                              /></em></span></span>&nbsp;</span>You may review, change, or terminate your account at any time.</em><span
                                                style="color: rgb(89, 89, 89);"
                                              ><span style="font-size: 15px;"><span
                                                class="block-component"
                                              ><span class="block-component" /></span></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div
                                              id="withdrawconsent"
                                              style="line-height: 1.5;"
                                            >
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><strong><u>Withdrawing your consent:</u></strong> If we are relying on your consent to process your personal information,<span
                                                class="block-component"
                                              /> which may be express and/or implied consent depending on the applicable law,<span
                                                class="statement-end-if-in-editor"
                                              /> you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us by using the contact details provided in the section <span
                                                class="block-component"
                                              />"<span
                                                class="statement-end-if-in-editor"
                                              /></span></span></span><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span></span></span><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><span class="block-component" />"<span
                                                class="statement-end-if-in-editor"
                                              /> below<span
                                                class="block-component"
                                              />.</span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span style="font-size: 15px;"><span
                                                data-custom-class="body_text"
                                              >However, please note that this will not affect the lawfulness of the processing before its withdrawal nor,<span
                                                class="block-component"
                                              /> when applicable law allows,<span
                                                class="statement-end-if-in-editor"
                                              /> will it affect the processing of your personal information conducted in reliance on lawful processing grounds other than consent.<span
                                                class="block-component"
                                              /></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span style="font-size: 15px;"><span
                                                data-custom-class="body_text"
                                              ><strong><u>Opting out of marketing and promotional communications:</u></strong><strong><u>&nbsp;</u></strong>You can unsubscribe from our marketing and promotional communications at any time by<span
                                                class="block-component"
                                              /> clicking on the unsubscribe link in the emails that we send,<span
                                                class="statement-end-if-in-editor"
                                              /><span
                                                class="block-component"
                                              /> replying <span
                                                class="block-component"
                                              />"STOP" or "UNSUBSCRIBE"<span
                                                class="statement-end-if-in-editor"
                                              /> to the SMS messages that we send,<span
                                                class="statement-end-if-in-editor"
                                              /><span
                                                class="block-component"
                                              /> or by contacting us using the details provided in the section <span
                                                class="block-component"
                                              />"<span
                                                class="statement-end-if-in-editor"
                                              /></span></span><span style="font-size: 15px;"><span
                                                data-custom-class="body_text"
                                              >HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span></span><span
                                                style="font-size: 15px;"
                                              ><span data-custom-class="body_text"><span
                                                class="block-component"
                                              />"<span
                                                class="statement-end-if-in-editor"
                                              /> below. You will then be removed from the marketing lists. However, we may still communicate with you — for example, to send you service-related messages that are necessary for the administration and use of your account, to respond to service requests, or for other non-marketing purposes.</span><span
                                                data-custom-class="body_text"
                                              ><span
                                                class="statement-end-if-in-editor"
                                              /></span></span>
                                              <span class="block-component"><span style="font-size: 15px;"><span
                                                data-custom-class="body_text"
                                              /></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span style="font-size: 15px;"><span
                                                data-custom-class="heading_2"
                                              ><strong>Account Information</strong></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span data-custom-class="body_text"><span
                                                style="font-size: 15px;"
                                              >If you would at any time like to review or change the information in your account or terminate your account, you can:<span
                                                class="forloop-component"
                                              /></span></span>
                                            </div>
                                            <ul>
                                              <li style="line-height: 1.5;">
                                                <span data-custom-class="body_text"><span
                                                  style="font-size: 15px;"
                                                ><span class="question">Viewable by Platinum members only</span></span></span>
                                              </li>
                                            </ul>
                                            <div style="line-height: 1.5;">
                                              <span data-custom-class="body_text"><span
                                                style="font-size: 15px;"
                                              ><span
                                                class="forloop-component"
                                              /></span></span>
                                            </div>
                                            <ul>
                                              <li style="line-height: 1.5;">
                                                <span data-custom-class="body_text"><span
                                                  style="font-size: 15px;"
                                                ><span class="question">Contact us using the contact information provided.</span></span></span>
                                              </li>
                                            </ul>
                                            <div style="line-height: 1.5;">
                                              <span data-custom-class="body_text"><span
                                                style="font-size: 15px;"
                                              ><span
                                                class="forloop-component"
                                              /></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span style="font-size: 15px;"><span
                                                data-custom-class="body_text"
                                              >Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, we may retain some information in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our legal terms and/or comply with applicable legal requirements.</span></span>
                                              <span class="statement-end-if-in-editor"><span
                                                style="font-size: 15px;"
                                              ><span
                                                data-custom-class="body_text"
                                              /></span></span>
                                              <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><span style="font-size: 15px;"><span
                                                style="color: rgb(89, 89, 89);"
                                              ><span style="font-size: 15px;"><span
                                                style="color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><span style="font-size: 15px;"><span
                                                style="color: rgb(89, 89, 89);"
                                              ><span
                                                class="block-component"
                                              /></span></span></span></span></span></span></span></span></span></span>
                                              <span class="block-component"><span style="font-size: 15px;"><span
                                                data-custom-class="body_text"
                                              /></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span data-custom-class="body_text"><span
                                                style="font-size: 15px;"
                                              >If you have questions or comments about your privacy rights, you may email us at <span
                                                class="question"
                                              >privacy@reserverm.com</span>.</span></span>
                                              <span class="statement-end-if-in-editor"><span
                                                style="font-size: 15px;"
                                              ><span
                                                data-custom-class="body_text"
                                              /></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div
                                              id="DNT"
                                              style="line-height: 1.5;"
                                            >
                                              <span
                                                style="color: rgb(127, 127, 127);"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                id="control"
                                                style="color: rgb(0, 0, 0);"
                                              ><strong><span
                                                data-custom-class="heading_1"
                                              >9. CONTROLS FOR DO-NOT-TRACK FEATURES</span></strong></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (<span
                                                class="block-component"
                                              />"DNT"<span
                                                class="statement-end-if-in-editor"
                                              />) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage no uniform technology standard for <span
                                                class="block-component"
                                              />recognizing<span
                                                class="statement-end-if-in-editor"
                                              /> and implementing DNT signals has been <span
                                                class="block-component"
                                              />finalized<span
                                                class="statement-end-if-in-editor"
                                              />. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this privacy notice.</span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div
                                              id="caresidents"
                                              style="line-height: 1.5;"
                                            >
                                              <span
                                                style="color: rgb(127, 127, 127);"
                                              ><span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                id="control"
                                                style="color: rgb(0, 0, 0);"
                                              ><strong><span
                                                data-custom-class="heading_1"
                                              >10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span></strong></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><strong><em>In Short:&nbsp;</em></strong><em>Yes, if you are a resident of California, you are granted specific rights regarding access to your personal information.</em></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >California Civil Code Section 1798.83, also known as the <span
                                                class="block-component"
                                              />"Shine The Light"<span
                                                class="statement-end-if-in-editor"
                                              /> law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.</span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >If you are under 18 years of age, reside in California, and have a registered account with Services, you have the right to request removal of unwanted data that you publicly post on the Services. To request removal of such data, please contact us using the contact information provided below and include the email address associated with your account and a statement that you reside in California. We will make sure the data is not publicly displayed on the Services, but please be aware that the data may not be completely or comprehensively removed from all our systems (e.g.<span
                                                class="block-component"
                                              />,<span
                                                class="statement-end-if-in-editor"
                                              /> backups, etc.).<span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                data-custom-class="body_text"
                                              ><span class="block-component" /></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                data-custom-class="heading_2"
                                                style="color: rgb(0, 0, 0);"
                                              ><span
                                                style="font-size: 15px;"
                                              ><strong>CCPA Privacy Notice</strong></span></span>
                                            </div>
                                            <div>
                                              <div><br></div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="color: rgb(127, 127, 127);"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >The California Code of Regulations defines a <span
                                                  class="block-component"
                                                />"resident"<span
                                                  class="statement-end-if-in-editor"
                                                /> as:</span></span></span></span></span></span>
                                              </div>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5; margin-left: 20px;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >(1) every individual who is in the State of California for other than a temporary or transitory purpose and</span></span></span>
                                            </div>
                                            <div style="line-height: 1.5; margin-left: 20px;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >(2) every individual who is domiciled in the State of California who is outside the State of California for a temporary or transitory purpose</span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >All other individuals are defined as <span
                                                class="block-component"
                                              />"non-residents."<span
                                                class="statement-end-if-in-editor"
                                              /></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >If this definition of <span
                                                class="block-component"
                                              />"resident"<span
                                                class="statement-end-if-in-editor"
                                              /> applies to you, we must adhere to certain rights and obligations regarding your personal information.</span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              ><strong>What categories of personal information do we collect?</strong></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                style="font-size: 15px; color: rgb(89, 89, 89);"
                                              ><span
                                                data-custom-class="body_text"
                                              >We have collected the following categories of personal information in the past twelve (12) months:<span
                                                style="color: rgb(89, 89, 89); font-size: 15px;"
                                              ><span
                                                data-custom-class="body_text"
                                              ><span class="block-component" /></span></span></span></span></span>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <table style="width: 100%;">
                                              <tbody>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                      style="font-size: 15px; color: rgb(89, 89, 89);"
                                                    ><span
                                                      data-custom-class="body_text"
                                                    ><strong>Category</strong></span></span></span>
                                                  </td>
                                                  <td style="width: 51.4385%; border-top: 1px solid black; border-right: 1px solid black;">
                                                    <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                      style="font-size: 15px; color: rgb(89, 89, 89);"
                                                    ><span
                                                      data-custom-class="body_text"
                                                    ><strong>Examples</strong></span></span></span>
                                                  </td>
                                                  <td style="width: 14.9084%; border-right: 1px solid black; border-top: 1px solid black; text-align: center;">
                                                    <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                      style="font-size: 15px; color: rgb(89, 89, 89);"
                                                    ><span
                                                      data-custom-class="body_text"
                                                    ><strong>Collected</strong></span></span></span>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >A. Identifiers</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 51.4385%; border-top: 1px solid black; border-right: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Contact details, such as real name, alias, postal address, telephone or mobile contact number, unique personal identifier, online identifier, Internet Protocol address, email address, and account name</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 14.9084%; text-align: center; vertical-align: middle; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >B. Personal information categories listed in the California Customer Records statute</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 51.4385%; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Name, contact information, education, employment, employment history, and financial information</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 14.9084%; text-align: center; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >C. Protected classification characteristics under California or federal law</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 51.4385%; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Gender and date of birth</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 14.9084%; text-align: center; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >D. Commercial information</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 51.4385%; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Transaction information, purchase history, financial details, and payment information</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 14.9084%; text-align: center; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >E. Biometric information</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 51.4385%; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Fingerprints and voiceprints</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 14.9084%; text-align: center; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >F. Internet or other similar network activity</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 51.4385%; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Browsing history, search history, online <span
                                                        class="block-component"
                                                      />behavior<span
                                                        class="statement-end-if-in-editor"
                                                      />, interest data, and interactions with our and other websites, applications, systems, and advertisements</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 14.9084%; text-align: center; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >G. Geolocation data</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 51.4385%; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Device location</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 14.9084%; text-align: center; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >H. Audio, electronic, visual, thermal, olfactory, or similar information</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 51.4385%; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Images and audio, video or call recordings created in connection with our business activities</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 14.9084%; text-align: center; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="width: 33.8274%; border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >I. Professional or employment-related information</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 51.4385%; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Business contact details in order to provide you our Services at a business level or job title, work history, and professional qualifications if you apply for a job with us</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="width: 14.9084%; text-align: center; border-right: 1px solid black; border-top: 1px solid black;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="border-left: 1px solid black; border-right: 1px solid black; border-top: 1px solid black; width: 33.8274%;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >J. Education Information</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="border-right: 1px solid black; border-top: 1px solid black; width: 51.4385%;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Student records and directory information</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="text-align: center; border-right: 1px solid black; border-top: 1px solid black; width: 14.9084%;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      /></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="border-width: 1px; border-color: black; border-style: solid; width: 33.8274%;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >K. Inferences drawn from other personal information</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="border-bottom: 1px solid black; border-top: 1px solid black; border-right: 1px solid black; width: 51.4385%;">
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      >Inferences drawn from any of the collected personal information listed above to create a profile or summary about, for example, an individual’s preferences and characteristics</span></span></span>
                                                    </div>
                                                  </td>
                                                  <td style="text-align: center; border-right: 1px solid black; border-bottom: 1px solid black; border-top: 1px solid black; width: 14.9084%;">
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        style="font-size: 15px; color: rgb(89, 89, 89);"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      ><span class="block-component" />NO<span
                                                        class="statement-end-if-in-editor"
                                                      ><span
                                                        data-custom-class="body_text"
                                                      /></span></span></span></span>
                                                    </div>
                                                    <div style="line-height: 1.5;">
                                                      <br>
                                                    </div>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style="border-left: 1px solid black; border-right: 1px solid black; border-bottom: 1px solid black;">
                                                    <span
                                                      data-custom-class="body_text"
                                                    >L. Sensitive Personal Information</span>
                                                  </td>
                                                  <td style="border-right: 1px solid black; border-bottom: 1px solid black; line-height: 1.5;">
                                                    <span class="block-component"><span
                                                      data-custom-class="body_text"
                                                    /></span>
                                                  </td>
                                                  <td
                                                    data-custom-class="body_text"
                                                    style="border-right: 1px solid black; border-bottom: 1px solid black; text-align: center; line-height: 1.5;"
                                                  >
                                                    <br>
                                                    <span class="block-component"><span
                                                      data-custom-class="body_text"
                                                    /></span>
                                                    NO
                                                    <span class="statement-end-if-in-editor"><span
                                                      data-custom-class="body_text"
                                                    /></span>
                                                    <br><br>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <div style="line-height: 1.5;">
                                              <span class="block-component" />
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <br>
                                            </div>
                                            <div style="line-height: 1.5;">
                                              <span class="block-component"><span data-custom-class="body_text" />
                                              </span>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >We may also collect other personal information outside of these categories through instances where you interact with us in person, online, or by phone or mail in the context of:<span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >Receiving help through our customer support channels;</span><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(89, 89, 89); font-size: 15px;"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(89, 89, 89); font-size: 15px;"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span style="font-size: 15px;"><span
                                                    style="color: rgb(89, 89, 89);"
                                                  ><span data-custom-class="body_text"><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >Participation in customer surveys or contests; and</span><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(89, 89, 89); font-size: 15px;"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(89, 89, 89); font-size: 15px;"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span style="font-size: 15px;"><span
                                                    style="color: rgb(89, 89, 89);"
                                                  ><span data-custom-class="body_text"><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >Facilitation in the delivery of our Services and to respond to your inquiries.</span><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(89, 89, 89); font-size: 15px;"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(89, 89, 89); font-size: 15px;"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span style="font-size: 15px;"><span
                                                    style="color: rgb(89, 89, 89);"
                                                  ><span data-custom-class="body_text"><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><strong>How do we use and share your personal information?</strong></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >More information about our data collection and sharing practices can be found in this privacy notice<span
                                                  class="block-component"
                                                /> and our Cookie Notice: <span
                                                  class="question"
                                                ><a
                                                  href="https://reserverm.com/cookie"
                                                  target="_blank"
                                                >https://reserverm.com/cookie</a></span><span
                                                  class="statement-end-if-in-editor"
                                                />.</span></span></span></span><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >You may contact us <span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span>by email at&nbsp;</span><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="question"
                                                >ccpa@reserverm.com</span>, <span
                                                  class="statement-end-if-in-editor"
                                                /><span
                                                  class="block-component"
                                                /></span><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component" /><span
                                                  class="block-component"
                                                ><span
                                                  data-custom-class="body_text"
                                                /></span></span></span></span></span><span
                                                  data-custom-class="body_text"
                                                >or by referring to the contact details at the bottom of this document.</span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >If you are using an <span
                                                  class="block-component"
                                                />authorized<span
                                                  class="statement-end-if-in-editor"
                                                /> agent to exercise your right to opt out we may deny a request if the <span
                                                  class="block-component"
                                                />authorized<span
                                                  class="statement-end-if-in-editor"
                                                /> agent does not submit proof that they have been validly <span
                                                  class="block-component"
                                                />authorized<span
                                                  class="statement-end-if-in-editor"
                                                /> to act on your behalf.</span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><strong>Will your information be shared with anyone else?</strong></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >We may disclose your personal information with our service providers pursuant to a written contract between us and each service provider. Each service provider is a for-profit entity that processes the information on our behalf, following the same strict privacy protection obligations mandated by the CCPA.</span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >We may use your personal information for our own business purposes, such as for undertaking internal research for technological development and demonstration. This is not considered to be <span
                                                  class="block-component"
                                                />"selling"<span
                                                  class="statement-end-if-in-editor"
                                                /> of your personal information.<span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >We have not disclosed, sold, or shared any personal information to third parties for a business or commercial purpose in the preceding twelve (12) months. We<span
                                                  style="color: rgb(89, 89, 89);"
                                                >&nbsp;</span>will not sell or share personal information in the future belonging to website visitors, users, and other consumers.<span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span data-custom-class="body_text"><span
                                                  class="statement-end-if-in-editor"
                                                /></span></span></span></span><span
                                                  class="block-component"
                                                /></span></span></span></span></span><span
                                                  data-custom-class="body_text"
                                                ><span style="color: rgb(0, 0, 0);"><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><strong>Your rights with respect to your personal data</strong></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><u>Right to request deletion of the data — Request to delete</u></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >You can ask for the deletion of your personal information. If you ask us to delete your personal information, we will respect your request and delete your personal information, subject to certain exceptions provided by law, such as (but not limited to) the exercise by another consumer of his or her right to free speech, our compliance requirements resulting from a legal obligation, or any processing that may be required to protect against illegal activities.</span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><u>Right to be informed — Request to know</u></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >Depending on the circumstances, you have a right to know:<span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >whether we collect and use your personal information;<span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >the categories of personal information that we collect;<span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >the purposes for which the collected personal information is used;<span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >whether we sell or share personal information to third parties;<span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >the categories of personal information that we sold, shared, or disclosed for a business purpose;<span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >the categories of third parties to whom the personal information was sold, shared, or disclosed for a business purpose;<span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >the business or commercial purpose for collecting, selling, or sharing personal information; and<span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span class="block-component"><span data-custom-class="body_text" />
                                                </span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span data-custom-class="body_text">the specific pieces of personal information we collected about you.<span
                                                    class="statement-end-if-in-editor"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >In accordance with applicable law, we are not obligated to provide or delete consumer information that is de-identified in response to a consumer request or to re-identify individual data to verify a consumer request.</span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><u>Right to Non-Discrimination for the Exercise of a Consumer’s Privacy Rights</u></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >We will not discriminate against you if you exercise your privacy rights.</span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <u><span data-custom-class="body_text">Right to Limit Use and Disclosure of Sensitive Personal Information</span></u>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span class="block-component"><span data-custom-class="body_text" />
                                                </span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span data-custom-class="body_text">We do not process consumer's sensitive personal information.</span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span class="statement-end-if-in-editor"><span
                                                  data-custom-class="body_text"
                                                /></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><u>Verification process</u></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >Upon receiving your request, we will need to verify your identity to determine you are the same person about whom we have the information in our system. These verification efforts require us to ask you to provide information so that we can match it with information you have previously provided us. For instance, depending on the type of request you submit, we may ask you to provide certain information so that we can match the information you provide with the information we already have on file, or we may contact you through a communication method (e.g.<span
                                                  class="block-component"
                                                />,<span
                                                  class="statement-end-if-in-editor"
                                                /> phone or email) that you have previously provided to us. We may also use other verification methods as the circumstances dictate.</span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >We will only use personal information provided in your request to verify your identity or authority to make the request. To the extent possible, we will avoid requesting additional information from you for the purposes of verification. However, if we cannot verify your identity from the information already maintained by us, we may request that you provide additional information for the purposes of verifying your identity and for security or fraud-prevention purposes. We will delete such additionally provided information as soon as we finish verifying you.</span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><u>Other privacy rights</u></span></span></span>
                                              </div>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >You may object to the processing of your personal information.<span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >You may request correction of your personal data if it is incorrect or no longer relevant, or ask to restrict the processing of the information.<span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >You can designate an <span
                                                    class="block-component"
                                                  />authorized<span
                                                    class="statement-end-if-in-editor"
                                                  /> agent to make a request under the CCPA on your behalf. We may deny a request from an <span
                                                    class="block-component"
                                                  />authorized<span
                                                    class="statement-end-if-in-editor"
                                                  /> agent that does not submit proof that they have been validly <span
                                                    class="block-component"
                                                  />authorized<span
                                                    class="statement-end-if-in-editor"
                                                  /> to act on your behalf in accordance with the CCPA.<span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div>
                                                <span style="font-size: 15px; color: rgb(89, 89, 89);"><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  >You may request to opt out from future selling or sharing of your personal information to third parties. Upon receiving an opt-out request, we will act upon the request as soon as feasibly possible, but no later than fifteen (15) days from the date of the request submission.<span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    style="font-size: 15px; color: rgb(89, 89, 89);"
                                                  ><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    style="color: rgb(0, 0, 0);"
                                                  ><span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  ><span
                                                    class="statement-end-if-in-editor"
                                                  /></span></span></span></span></span></span></span></span></span></span></span></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >To exercise these rights, you can contact us&nbsp;</span><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component" />by email at <span
                                                  class="question"
                                                >ccpa@reserverm.com</span>, <span
                                                  class="statement-end-if-in-editor"
                                                /><span
                                                  class="block-component"
                                                /></span><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component" /><span
                                                  class="block-component"
                                                ><span
                                                  data-custom-class="body_text"
                                                /></span></span></span></span></span></span></span><span
                                                  data-custom-class="body_text"
                                                >or by referring to the contact details at the bottom of this document. If you have a complaint about how we handle your data, we would like to hear from you.</span><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component"><span
                                                  class="block-component"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span class="statement-end-if-in-editor"><span
                                                  class="statement-end-if-in-editor"
                                                /></span></span></span></span></span></span></span></span></span></span></span></span></span></span></span>
                                                <span class="block-component"><span style="font-size: 15px;" />
                                                </span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><br></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  id="virginia"
                                                  style="font-size: 15px;"
                                                ><strong><span
                                                  data-custom-class="heading_1"
                                                >11. DO VIRGINIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span></strong></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><br></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><em><strong><span
                                                  data-custom-class="body_text"
                                                >In Short:</span></strong><span
                                                  data-custom-class="body_text"
                                                >&nbsp;Yes, if you are a resident of Virginia, you may be granted specific rights regarding access to and use of your personal information.</span></em></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><br></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px;"
                                                ><strong><span data-custom-class="heading_2">Virginia CDPA Privacy Notice</span></strong></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><br></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                >Under the Virginia Consumer Data Protection Act (CDPA):</span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><br></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component" />"Consumer"<span
                                                  class="statement-end-if-in-editor"
                                                /> means a natural person who is a resident of the Commonwealth acting only in an individual or household context. It does not include a natural person acting in a commercial or employment context.</span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><br></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component" />"Personal data"<span
                                                  class="statement-end-if-in-editor"
                                                /> means any information that is linked or reasonably linkable to an identified or identifiable natural person. <span
                                                  class="block-component"
                                                />"Personal data"<span
                                                  class="statement-end-if-in-editor"
                                                /> does not include de-identified data or publicly available information.</span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><br></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component" />"Sale of personal data"<span
                                                  class="statement-end-if-in-editor"
                                                /> means the exchange of personal data for monetary consideration.</span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><br></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                >If this definition <span
                                                  class="block-component"
                                                />"consumer"<span
                                                  class="statement-end-if-in-editor"
                                                /> applies to you, we must adhere to certain rights and obligations regarding your personal data.</span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                >The information we collect, use, and disclose about you will vary depending on how you interact with us and our Services. To find out more, please visit the following links:</span><span
                                                  class="block-component"
                                                /></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span style="font-size: 15px;">Personal data we collect<span
                                                    class="statement-end-if-in-editor"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span style="font-size: 15px;">How we use your personal data<span
                                                    class="statement-end-if-in-editor"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span style="font-size: 15px;">When and with whom we share your personal data<span
                                                    class="statement-end-if-in-editor"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><u><span
                                                  data-custom-class="body_text"
                                                >Your rights with respect to your personal data</span></u></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  >Right to be informed whether or not we are processing your personal data</span><span
                                                    class="statement-end-if-in-editor"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  >Right to access your personal data</span><span
                                                    class="statement-end-if-in-editor"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  >Right to correct inaccuracies in your personal data</span><span
                                                    class="statement-end-if-in-editor"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  >Right to request deletion of your personal data</span><span
                                                    class="statement-end-if-in-editor"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  >Right to obtain a copy of the personal data you previously shared with us</span><span
                                                    class="statement-end-if-in-editor"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /></span>
                                              </div>
                                              <ul>
                                                <li style="line-height: 1.5;">
                                                  <span style="font-size: 15px;"><span
                                                    data-custom-class="body_text"
                                                  >Right to opt out of the processing of your personal data if it is used for targeted advertising, the sale of personal data, or profiling in furtherance of decisions that produce legal or similarly significant effects (<span
                                                    class="block-component"
                                                  />"profiling"<span
                                                    class="statement-end-if-in-editor"
                                                  />)</span></span>
                                                  <span class="statement-end-if-in-editor"><span
                                                    style="font-size: 15px;"
                                                  /></span>
                                                </li>
                                              </ul>
                                              <div
                                                data-custom-class="body_text"
                                                style="line-height: 1.5;"
                                              >
                                                <span
                                                  data-custom-class="body_text"
                                                  style="font-size: 15px;"
                                                ><span
                                                  class="block-component"
                                                />We have not sold any personal data to third parties for business or commercial purposes. We will not sell personal data in the future belonging to website visitors, users, and other consumers.<span
                                                  class="else-block"
                                                /></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <u><span
                                                  data-custom-class="body_text"
                                                  style="font-size: 15px;"
                                                >Exercise your rights provided under the Virginia CDPA</span></u>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  data-custom-class="body_text"
                                                  style="font-size: 15px;"
                                                >More information about our data collection and sharing practices can be found in this privacy notice<span
                                                  class="block-component"
                                                /> and our Cookie Notice: <span
                                                  class="block-component"
                                                /><span class="question"><a
                                                  href="https://reserverm.com/cookie"
                                                  target="_blank"
                                                >https://reserverm.com/cookie</a></span><span
                                                  class="statement-end-if-in-editor"
                                                /><span
                                                  class="statement-end-if-in-editor"
                                                />.</span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span class="block-component" />
                                                <span style="font-size: 15px;"><span data-custom-class="body_text">You may contact us by email at <span
                                                  class="question"
                                                >privacy@reserverm.com</span>, <span
                                                  class="block-component"
                                                />by visiting <span class="question">sda@reserverm.com</span><span
                                                  class="else-block"
                                                />, or by referring to the contact details at the bottom of this document.</span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                >If you are using an <span
                                                  class="block-component"
                                                />authorized<span
                                                  class="statement-end-if-in-editor"
                                                /> agent to exercise your rights, we may deny a request if the <span
                                                  class="block-component"
                                                />authorized<span
                                                  class="statement-end-if-in-editor"
                                                /> agent does not submit proof that they have been validly <span
                                                  class="block-component"
                                                />authorized<span
                                                  class="statement-end-if-in-editor"
                                                /> to act on your behalf.</span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <u><span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                >Verification process</span></span></u>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                >We may request that you provide additional information reasonably necessary to verify you and your consumer's request. If you submit the request through an <span
                                                  class="block-component"
                                                />authorized<span
                                                  class="statement-end-if-in-editor"
                                                /> agent, we may need to collect additional information to verify your identity before processing your request.</span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                >Upon receiving your request, we will respond without undue delay, but in all cases, within forty-five (45) days of receipt. The response period may be extended once by forty-five (45) additional days when reasonably necessary. We will inform you of any such extension within the initial 45-day response period, together with the reason for the extension.</span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><u><span
                                                  data-custom-class="body_text"
                                                >Right to appeal</span></u></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><br></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                >If we decline to take action regarding your request, we will inform you of our decision and reasoning behind it.&nbsp;</span><span
                                                  data-custom-class="body_text"
                                                >If you wish to appeal our decision, please email us at <span
                                                  class="block-component"
                                                /><span class="question">privacy@reserverm.com</span><span
                                                  class="else-block"
                                                />. Within sixty (60) days of receipt of an appeal, we will inform you in writing of any action taken or not taken in response to the appeal, including a written explanation of the reasons for the decisions. If your appeal if denied, you may contact the&nbsp;</span></span><a
                                                  href="https://www.oag.state.va.us/consumer-protection/index.php/file-a-complaint"
                                                  rel="noopener noreferrer"
                                                  target="_blank"
                                                ><span
                                                  style="font-size: 15px;"
                                                ><span>Attorney General to submit a complaint</span></span></a><span
                                                  style="font-size: 15px;"
                                                ><span data-custom-class="body_text">.</span><span
                                                  class="statement-end-if-in-editor"
                                                /></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span class="block-component"><span style="font-size: 15px;" />
                                                </span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div
                                                id="policyupdates"
                                                style="line-height: 1.5;"
                                              >
                                                <span
                                                  style="color: rgb(127, 127, 127);"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  id="control"
                                                  style="color: rgb(0, 0, 0);"
                                                ><strong><span
                                                  data-custom-class="heading_1"
                                                >12. DO WE MAKE UPDATES TO THIS NOTICE?</span></strong></span></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><em><strong>In Short:&nbsp;</strong>Yes, we will update this notice as necessary to stay compliant with relevant laws.</em></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >We may update this privacy notice from time to time. The updated version will be indicated by an updated <span
                                                  class="block-component"
                                                />"Revised"<span
                                                  class="statement-end-if-in-editor"
                                                /> date and the updated version will be effective as soon as it is accessible. If we make material changes to this privacy notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.</span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div
                                                id="contact"
                                                style="line-height: 1.5;"
                                              >
                                                <span
                                                  style="color: rgb(127, 127, 127);"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  id="control"
                                                  style="color: rgb(0, 0, 0);"
                                                ><strong><span
                                                  data-custom-class="heading_1"
                                                >13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</span></strong></span></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >If you have questions or comments about this notice, you may <span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component" />email us at <span
                                                  class="question"
                                                >privacy@reserevrm.com</span><span
                                                  class="statement-end-if-in-editor"
                                                /></span></span><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                >&nbsp;or contact us by post at:</span></span></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span style="font-size: 15px;"><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span style="color: rgb(89, 89, 89);"><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  class="question"
                                                >RecommendMe, Inc.</span></span></span></span></span></span><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span data-custom-class="body_text"><span
                                                  class="block-component"
                                                /></span></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                ><span class="question">33 West Ontario, 53F</span><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                ><span class="question">Chicago</span><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span style="font-size: 15px;"><span
                                                  class="block-component"
                                                /><span class="block-component" />, <span
                                                  class="question"
                                                >IL</span><span
                                                  class="statement-end-if-in-editor"
                                                /><span
                                                  class="block-component"
                                                /><span class="block-component" /> <span
                                                  class="question"
                                                >60654</span><span
                                                  class="statement-end-if-in-editor"
                                                /><span
                                                  class="block-component"
                                                /><span class="block-component" /><span
                                                  class="block-component"
                                                /></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  data-custom-class="body_text"
                                                  style="font-size: 15px;"
                                                ><span
                                                  class="question"
                                                >United States<span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                ><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span style="font-size: 15px;"><span
                                                  class="statement-end-if-in-editor"
                                                /></span></span></span></span></span></span></span></span></span></span></span>
                                                <span class="block-component"><span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                /></span></span>
                                                <span class="statement-end-if-in-editor" />
                                                <span data-custom-class="body_text"><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span style="font-size: 15px;"><span
                                                  class="statement-end-if-in-editor"
                                                /></span></span></span><span
                                                  data-custom-class="body_text"
                                                ><span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                ><span style="color: rgb(89, 89, 89);"><span
                                                  class="statement-end-if-in-editor"
                                                ><span
                                                  style="color: rgb(89, 89, 89);"
                                                ><span style="font-size: 15px;"><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component"><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span></span><span
                                                  class="block-component"
                                                ><span style="font-size: 15px;" /></span><span
                                                  style="font-size: 15px;"
                                                ><span data-custom-class="body_text"><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  style="font-size: 15px;"
                                                ><span data-custom-class="body_text"><span
                                                  class="statement-end-if-in-editor"
                                                ><span
                                                  class="block-component"
                                                /></span></span></span></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div
                                                id="request"
                                                style="line-height: 1.5;"
                                              >
                                                <span
                                                  style="color: rgb(127, 127, 127);"
                                                ><span
                                                  style="color: rgb(89, 89, 89); font-size: 15px;"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  id="control"
                                                  style="color: rgb(0, 0, 0);"
                                                ><strong><span
                                                  data-custom-class="heading_1"
                                                >14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span></strong></span></span></span></span></span>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <br>
                                              </div>
                                              <div style="line-height: 1.5;">
                                                <span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  style="font-size: 15px; color: rgb(89, 89, 89);"
                                                ><span
                                                  data-custom-class="body_text"
                                                ><span class="block-component" />You have the right to request access to the personal information we collect from you, change that information, or delete it. <span
                                                  class="statement-end-if-in-editor"
                                                />To request to review, update, or delete your personal information, please <span
                                                  class="block-component"
                                                /></span><span
                                                  data-custom-class="body_text"
                                                >visit: <span class="question">sda@reserverm.com</span><span
                                                  class="else-block"
                                                /></span></span><span
                                                  data-custom-class="body_text"
                                                >.</span></span>
                                              </div>
                                            </div>
                                            <div
                                              style="color: #595959;font-size: 14px;font-family: Arial;padding-top:16px;"
                                            >
                                              This privacy policy was created using Termly's <a
                                                style="color: rgb(48, 48, 241) !important;"
                                                href="https://termly.io/products/privacy-policy-generator/"
                                              >Privacy
                                                Policy Generator</a>.
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!--      <v-sheet class="py-16"> -->
    <!--        <section id="filter"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive width="350"> -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    Become a Member -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    Exclusive Access -->
    <!--                  </p> -->

    <!-- &lt;!&ndash;                  <strong class="mt-3">&ndash;&gt; -->
    <!-- &lt;!&ndash;                    Version 3 Only&ndash;&gt; -->
    <!-- &lt;!&ndash;                  </strong>&ndash;&gt; -->

    <!--                  <p class="mt-8"> -->
    <!--                    For an annual fee members gain access to prime time reservations and private dining at their favorite restaurants. -->
    <!--                  </p> -->

    <!--                  <p class="mt-8"> -->
    <!--                    Our members get access to tables not available to the general public. -->
    <!--                  </p> -->

    <!--                  <v-btn -->
    <!--                    class="mt-6" -->
    <!--                    to="/members" -->
    <!--                  > -->
    <!--                    Learn More -->
    <!--                  </v-btn> -->
    <!--                  <v-btn -->
    <!--                    class="mt-6 ml-6" -->
    <!--                    to="/register" -->
    <!--                  > -->
    <!--                    JOIN NOW -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->

    <!--              <v-img -->
    <!--                max-width="400" -->
    <!--                :src="reservedImage" -->
    <!--              /> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->

    <!--        <v-container> -->
    <!--          <v-divider class="my-12" /> -->
    <!--        </v-container> -->

    <!--        <section id="controls"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive width="350"> -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    Most Booked in Chicago -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    And the list goes on... -->
    <!--                  </p> -->

    <!--                  <p class="mt-3"> -->
    <!--                    Aba, Adalina, Alla Vita, Avec, Bambola, Bazaar Meat, Chicago Cut, Duck Duck Goat, etta, Gibsons Italia, Gino & Marty's, Girl & the Goat, Le Colonial, Lyra, Maple & Ash, Momotaro, Proxi, RL Restaurant, RPMs, Steak 48, Summer House, Sunda, Sushi-San -->
    <!--                  </p> -->


    <!--                  <v-btn -->
    <!--                    class="mt-6" -->
    <!--                    to="/restaurants" -->
    <!--                  > -->
    <!--                    See All Restaurants -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->

    <!--              <v-img -->
    <!--                max-width="400" -->
    <!--                :src="chicagoImage" -->
    <!--              /> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->

    <!--        <v-container> -->
    <!--          <v-divider class="my-12" /> -->
    <!--        </v-container> -->

    <!--        <section id="grid"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive width="350"> -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    Most Booked in New York -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    And the list goes on... -->
    <!--                  </p> -->

    <!--                  <p class="mt-3"> -->
    <!--                    Aba, Adalina, Alla Vita, Avec, Bambola, Bazaar Meat, Chicago Cut, Duck Duck Goat, etta, Gibsons Italia, Gino & Marty's, Girl & the Goat, Le Colonial, Lyra, Maple & Ash, Momotaro, Proxi, RL Restaurant, RPMs, Steak 48, Summer House, Sunda, Sushi-San -->
    <!--                  </p> -->


    <!--                  <v-btn -->
    <!--                    class="mt-6" -->
    <!--                    to="/restaurants" -->
    <!--                  > -->
    <!--                    See All Restaurants -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->

    <!--              <v-img -->
    <!--                max-width="400" -->
    <!--                :src="nycImage" -->
    <!--              /> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->

    <!--        <v-container> -->
    <!--          <v-divider class="my-12" /> -->
    <!--        </v-container> -->

    <!--        <section id="grid"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive width="350"> -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    Most Booked in Miami -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    And the list goes on... -->
    <!--                  </p> -->

    <!--                  <p class="mt-3"> -->
    <!--                    Aba, Adalina, Alla Vita, Avec, Bambola, Bazaar Meat, Chicago Cut, Duck Duck Goat, etta, Gibsons Italia, Gino & Marty's, Girl & the Goat, Le Colonial, Lyra, Maple & Ash, Momotaro, Proxi, RL Restaurant, RPMs, Steak 48, Summer House, Sunda, Sushi-San -->
    <!--                  </p> -->


    <!--                  <v-btn -->
    <!--                    class="mt-6" -->
    <!--                    to="/restaurants" -->
    <!--                  > -->
    <!--                    See All Restaurants -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->

    <!--              <v-img -->
    <!--                max-width="400" -->
    <!--                :src="miamiImage" -->
    <!--              /> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->
    <!--      </v-sheet> -->

    <!--      <v-sheet -->
    <!--        class="py-16" -->
    <!--        color="#787878" -->
    <!--      > -->
    <!--        <section id="grid"> -->
    <!--          <v-container> -->
    <!--            <v-row justify="space-between"> -->
    <!--              <v-col cols="auto"> -->
    <!--                <v-responsive -->
    <!--                  class="overflow-visible" -->
    <!--                  width="350" -->
    <!--                > -->
    <!--                  <h2 class="text-h4"> -->
    <!--                    RM for Restaurants -->
    <!--                  </h2> -->

    <!--                  <p class="text-success mt-3"> -->
    <!--                    Receive high quality referrals at ZERO cost. -->
    <!--                  </p> -->

    <!-- &lt;!&ndash;                  <strong>Become a sponsor</strong>&ndash;&gt; -->

    <!--                  <p class="mt-8"> -->
    <!--                    Our members want to spend good money at your restaurant and are willing to guarantee it.                  </p> -->

    <!--                  <v-btn -->
    <!--                    class="mt-6 " -->
    <!--                    to="/preferred" -->
    <!--                  > -->
    <!--                    Learn More -->
    <!--                  </v-btn> -->
    <!--                </v-responsive> -->
    <!--              </v-col> -->
    <!--            </v-row> -->
    <!--          </v-container> -->
    <!--        </section> -->
    <!--      </v-sheet> -->
    <!--    <v-footer> -->
    <!--      <v-container class="text-overline d-flex align-center justify-space-between"> -->
    <!--        <div> -->
    <!--          Copyright &copy; 2022 RecommendMe, Inc. -->
    <!--        </div> -->

    <!--        <v-icon icon="mdi-vuetify" size="x-large" /> -->
    <!--      </v-container> -->
    <!--    </v-footer> -->
  </div>
</template>

<style lang="scss">
@use "@core/scss/pages/misc.scss";

.misc-footer-tree {
  inline-size: 15.625rem;
  inset-block-end: 3.5rem;
  inset-inline-start: 0.375rem;
}

ul {
  list-style-type: square;
  margin-left: 20px;
}

ul > li > ul {
  list-style-type: circle;
}

ul > li > ul > li > ul {
  list-style-type: square;
}

ol li {
  font-family: Arial;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
